import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    routes: [],
    metrics: {},
    tasks: [],
    collects: [],
  },
  mutations: {
    SET_ROUTES(state, payload) {
      state.routes = payload
    },
    SET_METRICS(state, payload) {
      state.metrics = payload
    },
    SET_TASKS(state, payload) {
      state.tasks = payload
    },
    SET_COLLECTS(state, payload) {
      state.collects = payload
    },
  },
  getters: {
    ROUTES: state => state.routes,
    METRICS: state => state.metrics,
    TASKS: state => state.tasks,
    COLLECTS: state => state.collects,
  },
}
